/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SapUserDataResponse } from './SapUserDataResponse';
import {
    SapUserDataResponseFromJSON,
    SapUserDataResponseFromJSONTyped,
    SapUserDataResponseToJSON,
    SapUserDataResponseToJSONTyped,
} from './SapUserDataResponse';
import type { SectionHistoryResponse } from './SectionHistoryResponse';
import {
    SectionHistoryResponseFromJSON,
    SectionHistoryResponseFromJSONTyped,
    SectionHistoryResponseToJSON,
    SectionHistoryResponseToJSONTyped,
} from './SectionHistoryResponse';
import type { UserKrrInfoResponse } from './UserKrrInfoResponse';
import {
    UserKrrInfoResponseFromJSON,
    UserKrrInfoResponseFromJSONTyped,
    UserKrrInfoResponseToJSON,
    UserKrrInfoResponseToJSONTyped,
} from './UserKrrInfoResponse';
import type { UserAliasResponse } from './UserAliasResponse';
import {
    UserAliasResponseFromJSON,
    UserAliasResponseFromJSONTyped,
    UserAliasResponseToJSON,
    UserAliasResponseToJSONTyped,
} from './UserAliasResponse';

/**
 * 
 * @export
 * @interface InternalUserDetailResponse
 */
export interface InternalUserDetailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InternalUserDetailResponse
     */
    isIdPortenUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalUserDetailResponse
     */
    isIdPortenValidated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InternalUserDetailResponse
     */
    lastLoggedInOn?: Date | null;
    /**
     * 
     * @type {Array<UserAliasResponse>}
     * @memberof InternalUserDetailResponse
     */
    userAliases?: Array<UserAliasResponse> | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    employeeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    internalUserId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InternalUserDetailResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    mail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    mailNickname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    onPremisesUserPrincipalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserDetailResponse
     */
    userPrincipalName?: string | null;
    /**
     * 
     * @type {SapUserDataResponse}
     * @memberof InternalUserDetailResponse
     */
    sapUserData?: SapUserDataResponse;
    /**
     * 
     * @type {UserKrrInfoResponse}
     * @memberof InternalUserDetailResponse
     */
    userKrrInfo?: UserKrrInfoResponse;
    /**
     * 
     * @type {Array<SectionHistoryResponse>}
     * @memberof InternalUserDetailResponse
     */
    sectionHistory?: Array<SectionHistoryResponse> | null;
}

/**
 * Check if a given object implements the InternalUserDetailResponse interface.
 */
export function instanceOfInternalUserDetailResponse(value: object): value is InternalUserDetailResponse {
    return true;
}

export function InternalUserDetailResponseFromJSON(json: any): InternalUserDetailResponse {
    return InternalUserDetailResponseFromJSONTyped(json, false);
}

export function InternalUserDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalUserDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isIdPortenUser': json['isIdPortenUser'] == null ? undefined : json['isIdPortenUser'],
        'isIdPortenValidated': json['isIdPortenValidated'] == null ? undefined : json['isIdPortenValidated'],
        'lastLoggedInOn': json['lastLoggedInOn'] === undefined ? undefined : json['lastLoggedInOn'] === null ? null : (new Date(json['lastLoggedInOn'])),
        'userAliases': json['userAliases'] === undefined ? undefined : json['userAliases'] === null ? null : ((json['userAliases'] as Array<any>).map(UserAliasResponseFromJSON)),
        'employeeId': json['employeeId'] === undefined ? undefined : json['employeeId'] === null ? null : json['employeeId'],
        'givenName': json['givenName'] === undefined ? undefined : json['givenName'] === null ? null : json['givenName'],
        'internalUserId': json['internalUserId'] === undefined ? undefined : json['internalUserId'] === null ? null : json['internalUserId'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'mail': json['mail'] === undefined ? undefined : json['mail'] === null ? null : json['mail'],
        'mailNickname': json['mailNickname'] === undefined ? undefined : json['mailNickname'] === null ? null : json['mailNickname'],
        'onPremisesUserPrincipalName': json['onPremisesUserPrincipalName'] === undefined ? undefined : json['onPremisesUserPrincipalName'] === null ? null : json['onPremisesUserPrincipalName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'userPrincipalName': json['userPrincipalName'] === undefined ? undefined : json['userPrincipalName'] === null ? null : json['userPrincipalName'],
        'sapUserData': json['sapUserData'] == null ? undefined : SapUserDataResponseFromJSON(json['sapUserData']),
        'userKrrInfo': json['userKrrInfo'] == null ? undefined : UserKrrInfoResponseFromJSON(json['userKrrInfo']),
        'sectionHistory': json['sectionHistory'] === undefined ? undefined : json['sectionHistory'] === null ? null : ((json['sectionHistory'] as Array<any>).map(SectionHistoryResponseFromJSON)),
    };
}

export function InternalUserDetailResponseToJSON(json: any): InternalUserDetailResponse {
    return InternalUserDetailResponseToJSONTyped(json, false);
}

export function InternalUserDetailResponseToJSONTyped(value?: InternalUserDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isIdPortenUser': value['isIdPortenUser'],
        'isIdPortenValidated': value['isIdPortenValidated'],
        'lastLoggedInOn': value['lastLoggedInOn'] == null ? value['lastLoggedInOn'] : value['lastLoggedInOn'].toISOString(),
        'userAliases': value['userAliases'] == null ? undefined : ((value['userAliases'] as Array<any>).map(UserAliasResponseToJSON)),
        'employeeId': value['employeeId'],
        'givenName': value['givenName'],
        'internalUserId': value['internalUserId'],
        'isActive': value['isActive'],
        'mail': value['mail'],
        'mailNickname': value['mailNickname'],
        'onPremisesUserPrincipalName': value['onPremisesUserPrincipalName'],
        'surname': value['surname'],
        'userId': value['userId'],
        'userPrincipalName': value['userPrincipalName'],
        'sapUserData': SapUserDataResponseToJSON(value['sapUserData']),
        'userKrrInfo': UserKrrInfoResponseToJSON(value['userKrrInfo']),
        'sectionHistory': value['sectionHistory'] == null ? undefined : ((value['sectionHistory'] as Array<any>).map(SectionHistoryResponseToJSON)),
    };
}

